import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router';
import { IconButton } from '../../forms';
import { Icon, IconName } from '../../medias';

type DrawerCloseLinkProps = LinkProps;

export function DrawerCloseLink(props: DrawerCloseLinkProps): ReactNode {
  return (
    <IconButton
      variant="secondary"
      as={Link}
      to={props.to}
      aria-label="Close"
      size="sm"
      borderRadius="radii.x2"
      position="absolute"
      right="4"
    >
      <Icon name={IconName.Close} width="5" height="5" />
    </IconButton>
  );
}
